export default __webpack_public_path__ + "static/media/ads2.fb2ebd65.png";